/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col} from "react-bootstrap";


export const SessionEndingInformationTextComponent: React.FC = (): JSX.Element | null => {


    return (
        <Col xs={12} className={"session-communicate-text-component session-communicate-text"}>
            <span>{`Aby pozostać w aplikacji eKiosk kliknij w poniższy przycisk`}</span>
        </Col>
    );

};


export default SessionEndingInformationTextComponent;
